export default {
  getAdLogData: {
    url: '/operationads/operation/history',
    method: 'post',
    desc: '广告日志初始数据'
  },
  campaignList: {
    url: '/operationads/report/campaign/list',
    method: 'post',
    desc: '广告活动筛选下拉数据'
  }
}
